import { render } from "./GraphWrapper.vue?vue&type=template&id=84bd45c4"
import script from "./GraphWrapper.vue?vue&type=script&lang=js"
export * from "./GraphWrapper.vue?vue&type=script&lang=js"

import "./GraphWrapper.vue?vue&type=style&index=0&id=84bd45c4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__